import { InputProptypes, wrap } from 'components/form/InputWrapper'
import { forwardRef } from 'react'

const TextInput = forwardRef(
  (
    {
      id,
      name,
      value,
      defaultValue,
      onFocus,
      autoFocus,
      onBlur,
      onChange,
      onError,
      maxLength,
    },
    ref
  ) => (
    <input
      type="text"
      className="inp_txt"
      id={id}
      name={name}
      value={value}
      defaultValue={defaultValue}
      ref={ref}
      autoFocus={autoFocus}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={onChange}
      maxLength={maxLength}
    />
  )
)

TextInput.propTypes = InputProptypes
TextInput.displayName = 'TextInput'

export default wrap(TextInput)
